import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createAppKit } from "@reown/appkit/react";
import { mainnet, sepolia, base, gnosis } from "@reown/appkit/networks";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import config from "./services/config/homestead.json";
import verifiedLogo from "./assets/images/icon128.png";
import { GlobalProvider } from "./context/globalContext";
import { chainConfig } from "viem/zksync";
import { networks } from "./utils/constants";

const projectId = config.keys.walletConnect;

const supportedNetworks = [sepolia, gnosis, base, mainnet];

const metadata = {
  name: "Verified Network",
  description:
    "The decentralized web application for payments, financing and investments on the Verified Network",
  url: window.location.origin,
  icons: [verifiedLogo],
};

const customRpcUrls = {
  "eip155:1": [{ url: networks[1]?.rpcUrls[0] }],
  "eip155:8453": [{ url: networks[8453]?.rpcUrls[0] }],
  "eip155:100": [{ url: networks[100]?.rpcUrls[0] }],
  "eip155:11155111": [{ url: networks[11155111]?.rpcUrls[0] }],
};

export const wagmiAdapter = new WagmiAdapter({
  networks: supportedNetworks,
  projectId,
  customRpcUrls,
});

createAppKit({
  adapters: [wagmiAdapter],
  networks: supportedNetworks,
  metadata,
  projectId,
  features: {
    analytics: true,
    onramp: true,
  },
  customRpcUrls,
});

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <WagmiProvider config={wagmiAdapter.wagmiConfig}>
    <QueryClientProvider client={queryClient}>
      <GlobalProvider>
        <App />
      </GlobalProvider>
    </QueryClientProvider>
  </WagmiProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
